import React from "react";

import ListItem from "../../components/ListItem";
import Link from "../../components/Link";
import Image from "../../components/Image";
import Name from "../../components/Name";
import Description from "../../components/Description";

import { TopperItem } from "../../../../types";

/**
 * This variant represents display type 1 and 2
 * @param url
 * @param itemId
 * @param image
 * @param name
 * @param description
 */
const ImageTitleAndDescription = ({
  url,
  itemId,
  image,
  name,
  description,
}: TopperItem) => (
  <ListItem>
    <Link
      className="max-w-[220px]"
      href={url}
      data-testid={`topper-item-${itemId}`}
    >
      <Image
        src={image}
        width="1"
        height="1"
        className="max-w-none h-16 w-16"
        loading="eager"
        alt=""
      />
      <div>
        <Name className="text-base text-left leading-4">{name}</Name>
        <Description>{description}</Description>
      </div>
    </Link>
  </ListItem>
);

export default ImageTitleAndDescription;
